import isPropValid from '@emotion/is-prop-valid';
import { logger } from './logger';

const hexRegex = /^#([A-Fa-f0-9]{3}){1,2}$/;

export const hexToRgba = (hex, opacity = 1) => {
  if (!hex) return null;

  const cleanHex = hex.trim().replace(/[^a-zA-Z0-9#]/g, '');
  let c;

  if (hexRegex.test(cleanHex)) {
    c = cleanHex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join('')}`;

    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(', ')}, ${opacity})`;
  }
};

export const checkHex = (hex) => !!(hex && hexRegex.test(hex.trim()));

// default is left aligned
export const checkAlignmentOption = (option) => {
  const options = ['left', 'center', 'right', 'justify', 'inherit'];

  if (!option) return options[0];

  if (options.includes(option.toLowerCase())) return option.toLowerCase();

  return options[0];
};

/**
 * Determines whether a styled-component prop should be forwarded to the DOM.
 * For real DOM elements (string elementType), only forward valid HTML attributes.
 * For custom React components (function elementType), always forward all props.
 *
 * Without this guard, a global shouldForwardProp using isPropValid alone will
 * silently strip non-HTML props (e.g. `carousel`, `isPagination`) even when
 * they are being forwarded to a custom React component, breaking functionality.
 *
 * @see https://styled-components.com/docs/faqs#why-am-i-getting-html-attribute-warnings
 *
 * @param {string} propName
 * @param {string|Function} elementType
 * @returns {boolean}
 */
export const styledComponentsShouldForwardProp = (propName, elementType) =>
  typeof elementType === 'string' ? isPropValid(propName) : true;

export const getResponsiveTypography = (theme, typographyKey, styleProp, width = 1040) => {
  if (!theme || !typographyKey || !styleProp) {
    logger.error('Missing required parameters theme, typographyKey and styleProp.');
    return '';
  }
  const breakpoints = {
    tablet: theme.breakpoints.a, // 480 - 1039 px
    desktop: theme.breakpoints.ba, // 1040+ px
  };

  let deviceType = 'desktop';
  if (width < breakpoints.desktop) {
    deviceType = 'tablet';
  }
  if (width < breakpoints.tablet) {
    deviceType = 'mobile';
  }

  const { desktop, tablet, mobile } = theme.typography[typographyKey];

  const selectedStyle = {
    desktop: desktop[styleProp],
    tablet: tablet[styleProp],
    mobile: mobile[styleProp],
  }[deviceType];

  return `${selectedStyle}`;
};
